import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Select,
} from 'antd';
import OfferActions from '@Actions/offerActions';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';

import './style.scss';
import PRZSelect from '../UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const SelectProductSeller = ({
  offers, updateData, currentKey, data,
  getOffers, getOffersLoading, tenantProductId, getPopupContainer, disabled, showError, title, hideTitle, onChange, customStyle, selectedSeller, notRequired, containerClass, labelClassName, inputClassName, setIsSellerChange,
}) => {
  useEffect(() => {
    if (tenantProductId) {
      getOffers(tenantProductId, '');
    }
  }, []);

  return (
    <div className={`${containerClass} select-product-vendor__wrapper` || 'orgInputContainer select-product-vendor__wrapper'}>
      {!hideTitle ? (
        <div className={labelClassName || 'orgFormLabel'}>
          {title || 'Select Vendor'}
          {!notRequired && <span style={{ color: 'red' }}>{'  *'}</span>}
        </div>
      ) : <label /> }
      <div className={inputClassName || 'orgFormInput input'}>

        <PRZSelect
          value={selectedSeller}
          filterOption={false}
          getPopupContainer={getPopupContainer ? (triggerNode) => triggerNode.parentNode : false}
          placeholder="Select vendor.."
          disabled={disabled}
          loading={getOffersLoading}
          onChange={(value) => {
            const requiredData = offers?.offers?.filter((offer) => ((offer?.seller_info?.seller_id) === value))[0];

            const copyData = JSON.parse(JSON.stringify(data));
            const updatedData = copyData.map((obj) => {
              if (obj.key === currentKey) {
                return {
                  ...obj, seller_id: requiredData?.seller_info?.seller_id, seller_name: requiredData?.seller_info?.seller_name,
                };
              }
              return obj;
            });
            updateData(updatedData);
            setIsSellerChange(true);
          }}
          style={customStyle || {
            height: '28px',
            width: '100%',
          }}
          showSearch
          onSelect={() => {
            getOffers(tenantProductId, '');
          }}
          showError={showError}
          errorName="*Please select a vendor"
          errorClassName="input-error"
        >
          {offers && offers?.offers && offers?.offers?.map((item) => (
            <Option key={item?.seller_info?.seller_id} value={item?.seller_info?.seller_id}>
              {`${item?.seller_info?.seller_name }`}
            </Option>
          ))}
        </PRZSelect>
      </div>
    </div>

  );
};

const mapStateToProps = ({ UserReducers, OfferReducers }) => ({
  user: UserReducers.user,
  offers: OfferReducers.offers,
  getOffersLoading: OfferReducers.getOffersLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getOffers: (tenantProductId, tenantSellerId) => dispatch(OfferActions.getOffers(tenantProductId, tenantSellerId)),
});

SelectProductSeller.propTypes = {
  user: PropTypes.any,
  getOffers: PropTypes.func,
  offers: PropTypes.any,
  getOffersLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectProductSeller));
